<template>
    <button-default @click="$router.push(props.to)">
        <svg-icon
            :icon="ArrowLeftLongIcon"
            :color="'primary'"
            :size="IconSize.md"
            is-custom-icon
        />
    </button-default>
</template>

<script setup lang="ts">
    import ArrowLeftLongIcon from '@keyvue/one-awesome-icons/icons/regular/arrow-left-long.svg?component';
    import { IconSize } from '@keyvue/one-ui';
    import type { RouteLocationRaw } from 'vue-router';

    export interface Props {
        to: RouteLocationRaw
    }

    const props = defineProps<Props>();
</script>
